import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { Model } from './model.model';
import { ModelService } from './model.service';

@Component({
    selector: 'dcs-model-detail',
    templateUrl: './model-detail.component.html'
})
export class ModelDetailComponent implements OnInit, OnDestroy {

    model: Model;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private modelService: ModelService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['model']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load (id) {
        this.modelService.find(id).subscribe(model => {
            this.model = model;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/model/model-detail.component.ts